import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { ShelvableBackend } from './ShelvableBackend'
import { Observable } from 'rxjs'
import { NgZone } from '@angular/core'
import { Analytics } from '../../services/Analytics'

export type MiniBook = {
    googleId:string,
    $key:string
}

export class BookArray {
    public static debugMode:boolean = false;
    constructor(public data:Observable<MiniBook[]>, private firebaseObj:FirebaseListObservable<any>) {}
    
    async addBook(googleId:string, addToStart:boolean) {
        NgZone.assertInAngularZone();
        if (BookArray.debugMode) {
            console.log('adding book to ' + this.firebaseObj.$ref.toString());
        }
        Analytics.addBook();
        var array:MiniBook[] = await this.data.take(1).toPromise();

        var promise:Promise<any>;
        if (addToStart) {
            var updates = {};
            for (var i = 0; i < array.length; i++) {
                var book = array[i];
                updates[book.$key + '/.priority']  = i + 1;
            }
            
            promise = <Promise<any>> this.firebaseObj.$ref.ref.update(updates);
        } else {
            promise = this.alignPriorities();
        }
        
        await promise;
        NgZone.assertInAngularZone();
        await this.firebaseObj.push({googleId: googleId, '.priority': (addToStart ? 0 : array.length)}); 
        await this.alignPriorities();
    
    }


    async deleteBook(bookKey:string):Promise<void> {
        NgZone.assertInAngularZone();
        if (BookArray.debugMode) {
            console.log('deleting book from ' + this.firebaseObj.$ref.toString());
        }
        if (bookKey) {
            // if book is null then the whole list might be nuked (!)
            try {
                await this.firebaseObj.remove(bookKey)
                await this.alignPriorities();
            } catch (err) {
                console.error(err);
            }
        }
    }
    
    async alignPriorities():Promise<void> {
        var list:MiniBook[] = await this.data.take(1).toPromise();

        list.sort((a, b) => {
            return a['.priority'] - b['.priority'];
        });
        var updates = {};
        for (var i = 0; i < list.length; i++) {
            if (list[i]['.priority'] !== i) {
                console.log('changing priority of ' + list[i].$key + ' to ' + i);
                updates[list[i].$key + '/.priority'] = i;
            }
        }
        try {
            await this.firebaseObj.$ref.ref.update(updates);
            NgZone.assertInAngularZone();
            console.log('updated priorities')
        } catch (error) {
            console.error(error);
        }
    }

    async getById(bookId:string):Promise<MiniBook> {
        NgZone.assertInAngularZone();
        //TODO: find a better way of doing this
        var snapshot = await this.firebaseObj.$ref.ref.child(bookId).once('value');
        NgZone.assertInAngularZone();

        if (snapshot.exists()) {
            var book = snapshot.val();
            book['.priority'] = snapshot.getPriority();
            return book;
        } else {
            return null;
        }
    
    }

    async getLength():Promise<number> {
        NgZone.assertInAngularZone();
        return (await this.data.take(1).toPromise()).length;
    }

    
    async insertBefore(bookId, bookToInsert) {
        //this.zone.run(() => {
            NgZone.assertInAngularZone();
            // inserts bookToInsert before the book with id=bookId.
            // if bookId is null, inserts bookToInsert at the end
    
            if (BookArray.debugMode) {
                console.log('inserting ' + (bookToInsert.$key ? 'book ' + bookToInsert.$key : 'new book ') + (bookId ? ' before book ' + bookId : 'at end'));
            }
    
            var newPriority:number;
            if (bookId) {
                newPriority = (await this.getById(bookId))['.priority'] - 0.5;
            } else {
                newPriority = await (this.getLength()) - 0.5;
            }

            var bookExists:boolean;
            if (bookToInsert.$key) {
                bookExists= !!(await this.getById(bookToInsert.$key));
            } else {
                bookExists = false;
            }

            if (bookExists) {
                // same shelf - just change the priority of the existing record
                //this.zone.runOutsideAngular(() => {
                    var priority:number = await newPriority
                    await this.firebaseObj.update(bookToInsert.$key, {
                        '.priority': priority
                    });

                    await this.alignPriorities();
                //})
            } else {
                if (BookArray.debugMode) {
                    console.log('Moving book ' + bookToInsert.$key + ' to different shelf');
                }
    
                var priority:number = await newPriority;
                bookToInsert['.priority'] = priority;
                await this.firebaseObj.push(bookToInsert);
                await this.alignPriorities();
            }
        //});
    }
}


// WEBPACK FOOTER //
// ./web/static/services/ShelvableBackend/BookArray.ts